import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { basicFormatDate, getFormattedDate } from "@Shared/utils/helpers/dates";
import { isEmpty } from "lodash";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DatepickerInput",
  model: {
    prop: "value",
    event: "change"
  },
  props: {
    name: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: "YYYY-MM-DD"
    },
    value: {
      type: [String, Object],
      default: ""
    },
    pastDate: {
      type: Boolean,
      default: false
    },
    futureDate: {
      type: Boolean,
      default: false
    },
    showCalendar: {
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ""
    },
    minDate: {
      type: String,
      default: null
    },
    maxDate: {
      type: String,
      default: null
    },
    placement: {
      type: String,
      default: "auto"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: [String, Number],
      default: "0"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    withInput: {
      type: Boolean,
      default: true
    },
    onlyMonths: {
      type: Boolean,
      default: false
    },
    monthLabel: {
      type: String,
      default: ""
    },
    isRange: {
      type: Boolean,
      default: false
    },
    positionFixed: {
      type: Boolean,
      default: false
    },
    showArrowIcon: {
      type: Boolean,
      default: true
    },
    rangeColOptions: {
      type: Object,
      default: () => ({
        cols: "12",
        lg: "4",
        md: "5",
        sm: "8"
      })
    },
    id: {
      type: String,
      default: ""
    },
    maturityDate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      today: getFormattedDate(new Date()),
      date: "",
      masks: {
        input: "YYYY-MM-DD"
      },
      attributes: [{
        key: "today",
        highlight: {
          fillMode: "light",
          color: "primary"
        },
        dates: getFormattedDate(new Date())
      }],
      range: {
        start: "",
        end: ""
      },
      modelConfig: {
        type: "string",
        mask: "YYYY-MM-DD",
        timeAdjust: "12:00:00"
      },
      labelValue: uuidv4()
    };
  },
  computed: {
    locale() {
      return this.$root.$i18n.locale.replace("-CA", "");
    },
    datesAreValid() {
      return this.pastDate !== this.futureDate || !(this.pastDate || this.futureDate);
    },
    computedMinDate() {
      var _context, _this$minDate;
      const defaultMinDate = this.futureDate || _includesInstanceProperty(_context = this.splittedClassName).call(_context, "future-date") ? this.today : null;
      return (_this$minDate = this.minDate) != null ? _this$minDate : defaultMinDate;
    },
    computedMaxDate() {
      var _context2, _this$maxDate;
      const defaultMaxDate = this.pastDate || _includesInstanceProperty(_context2 = this.splittedClassName).call(_context2, "past-date") ? this.today : null;
      return (_this$maxDate = this.maxDate) != null ? _this$maxDate : defaultMaxDate;
    },
    formattedDate() {
      const isValidDate = moment(this.date).isValid();
      return isValidDate ? basicFormatDate(this.date) : "";
    },
    splittedClassName() {
      var _context3;
      return _mapInstanceProperty(_context3 = this.className.split(" ")).call(_context3, className => _trimInstanceProperty(className).call(className));
    },
    formattedRange() {
      return {
        start: this.range ? basicFormatDate(this.range.start) : null,
        end: this.range ? basicFormatDate(this.range.end) : null
      };
    }
  },
  watch: {
    monthLabel() {
      this.setMonthLabel();
    },
    value(value) {
      if (this.value.start instanceof String || this.value.end instanceof String) {
        if (this.isRange) this.range = value;else if (value !== this.date) this.handleChange(value);
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!this.datesAreValid) throw new Error("Picker cannot be PastDate and FutureDate at the same time");
      this.date = this.value;
      if (!(this.withInput || isEmpty(this.value))) this.attributes.push({
        key: "selected",
        highlight: true,
        dates: basicFormatDate(this.value)
      });
      this.setMonthLabel();
    },
    handleChange(value, triggerInput = false) {
      if (this.isRange) {
        this.$emit("change", this.formattedRange);
        return;
      }
      if (this.computedMaxDate && value > getFormattedDate(this.computedMaxDate, "YYYY-MM-DD") || this.computedMinDate && value < getFormattedDate(this.computedMinDate, "YYYY-MM-DD")) this.date = null;else this.date = value;
      this.$emit("change", this.formattedDate);
      if (isEmpty(this.formattedDate)) {
        this.$refs.noRangePicker.value_ = null;
        $(this.$refs.input).val(null).trigger("input");
      }
      if (triggerInput) $(this.$refs.input).val(this.formattedDate).trigger("input");
    },
    handleBlur(event) {
      var _this$$parent$handleB, _this$$parent;
      this.$emit("blur", event);
      (_this$$parent$handleB = (_this$$parent = this.$parent).handleBlur) == null ? void 0 : _this$$parent$handleB.call(_this$$parent, event);
    },
    handleFocus(event, togglePopover) {
      var _this$$parent$handleF, _this$$parent2;
      togglePopover({
        placement: this.placement,
        positionFixed: this.positionFixed
      });
      this.$emit("focus", event);
      (_this$$parent$handleF = (_this$$parent2 = this.$parent).handleFocus) == null ? void 0 : _this$$parent$handleF.call(_this$$parent2, event);
    },
    iconClick() {
      if (!this.disabled) {
        this.$refs.input.focus();
      }
    },
    handleDayClick(day) {
      var _context4;
      const selected = _findInstanceProperty(_context4 = this.attributes).call(_context4, attr => attr.key === "selected");
      if (!isEmpty(selected) && selected.dates === day.date) return;
      if (isEmpty(selected)) this.attributes.push({
        key: "selected",
        highlight: true,
        dates: day.date
      });else selected.dates = day.date;
      this.handleChange(day.date);
    },
    handleMonthChange({
      month,
      year
    }) {
      this.$emit("change-month", `${year}/${month}`);
    },
    setMonthLabel() {
      if (!isEmpty(this.monthLabel)) {
        this.$refs.datepicker.pages[0].title = this.monthLabel;
      }
    }
  }
});